'use client'

import { useState } from 'react'
import useIsHydrated from '@/utils/hooks/useIsHydrated'
import { offersEnabledFor } from '@/utils/offers'
import MakeOfferModal from './make-offer-modal'
import PlaceBidLabel from './place-bid-label'
import styles from './trade-panel.module.css'

/**
 * Make Offer under Instant Sell in the Buy rail, matching the pair in the
 * right-hand Offers panel. One tap opens the collection offer form.
 */
export default function MakeOfferButton({
	slug,
	name,
	className = ''
}: {
	slug: string
	name?: string | null
	className?: string
}) {
	const hydrated = useIsHydrated()
	const [open, setOpen] = useState(false)
	if (!hydrated || !offersEnabledFor(slug)) return null
	return (
		<>
			{/* The right-hand Offers panel's button, exactly: same class, same label. */}
			<button
				type="button"
				className={`${styles.primary} ${className}`}
				onClick={() => setOpen(true)}
				aria-label={`Make an offer on ${name || slug}`}
				data-testid="buy-row-make-offer"
			>
				<PlaceBidLabel />
			</button>
			{open && (
				<MakeOfferModal
					open
					onClose={() => setOpen(false)}
					collectionSlug={slug}
					initialScope="collection"
					name={name || slug}
				/>
			)}
		</>
	)
}
